export default {
	name: "FetchesDataMixin",

	data: () => ( {
		fetched: false,
		fetching: false
	} ),

	computed: {
		fetchingName() {
			return this.$options.name || this.$vnode.tag;
		},

		fetchedEvent() {
			return `${this.fetchingName}.fetched`;
		}
	},

	watch: {
		fetching( fetching ) {
			if ( fetching ) {
				this.$wait.start( this.fetchingName );
			} else {
				this.$wait.end( this.fetchingName );
			}
		}
	},

	async created() {
		this.fetching = true;

		try {
			if ( this.fetch ) {
				await this.fetch();
			}
		} finally {
			this.fetched = true;
			this.fetching = false;

			this.$emit( this.fetchedEvent );
		}
	},

	destroyed() {
		this.$wait.end( this.fetchingName );
	}
};
